// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___COG2k","m-signature-pad--body":"styles__m-signature-pad--body___208Wg","m-signature-pad--footer":"styles__m-signature-pad--footer___3NDHk","description":"styles__description___FTtUq","button":"styles__button___1mjoa","clear":"styles__clear___6O0wV","save":"styles__save___2VWWz","m-signature-pad":"styles__m-signature-pad___q1GbI","github":"styles__github___3p24A","editBtn":"styles__editBtn___3v7rx","inputElement":"styles__inputElement___1-SRy","errorMsg":"styles__errorMsg___1lqGd","datepicker":"styles__datepicker___Lf0mh"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/users/UserDetailsBadgeInfo/styles.scss
// module id = Qdpz
// module chunks = client